import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-audit-support',
  templateUrl: './audit-support.component.html',
  styleUrls: ['./audit-support.component.scss']
})
export class AuditSupportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
